import { createSlice, createAsyncThunk,createAction } from "@reduxjs/toolkit";
import studentService from "./studentService";

export const getUsers = createAsyncThunk(
  "student/get-students",
  async (thunkAPI) => {
    try {
      return await studentService.getUsers();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getaUser = createAsyncThunk(
  "student/get-student",
  async (id, thunkAPI) => {
    try {
      return await studentService.getaUser(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const createUser = createAsyncThunk(
  "student/create-student",
  async (userData, { rejectWithValue }) => {
    try {
      return await studentService.createUser(userData);
    } catch (error) {
      if (error.response && error.response.status === 400) {
        const errorMessage = error.response.data.message;
        return rejectWithValue(errorMessage);
      } else {
        const errorMessage = "Something Went Wrong!";
        return rejectWithValue(errorMessage);
      }
    }
  }

);
export const resetState = createAction("Reset_all");

const initialState = {
  students: [],
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
  errorMessage: ""

};

export const studentSlice = createSlice({
  name: "student",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getUsers.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getUsers.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.students = action.payload;
      })
      .addCase(getUsers.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
        state.errorMessage = action.error.message;

      })
      .addCase(createUser.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createUser.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.createdcustomers = action.payload;
      })
      .addCase(createUser.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
        state.errorMessage = action.error.message;

      })
      .addCase(resetState, () => initialState);
  },
});


export default studentSlice.reducer;
